import React, { useContext } from "react";
import Footer from "../components/Footer";
import { HeaderContext } from "../components/Header";
import { AiFillDelete } from "react-icons/ai";
import { BsCartX } from "react-icons/bs";

import axios from "axios";
import Swal from "sweetalert2";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Global, { getIsStripeSupportedCurrency, getProcessingFee } from "../util/Global";
import { LoaderComponent } from "../util/Loader";
import { AlertContext } from "../util/Alerter";
import { CurrencyContext } from "../components/Utils";
import { GlobalData } from "../util/GlobalData";
import { useStripe } from "@stripe/react-stripe-js";
import { Button, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";


const CART_URL = Global.backend + "/index.php/api/panier/showall";
const UPDATE_QT_URL = Global.backend + "/index.php/api/panier/editQt";


const DELETE_CART_URL = Global.backend + "/index.php/api/panier/delete";
const COMMANDE_URL = Global.backend + "/index.php/api/commande/new";
const CREATE_PAYMENT_SESSION = Global.backend + "/index.php/api/commande/stripe_payment";


const Cart = () => {
  const [productList, setProductList] = useState([]);
  const [isLoading, setisLoading] = useState(true)
  const [total, setTotal] = useState(0);
  const { t } = useTranslation();
  const { showAlert } = useContext(AlertContext)
  const { cartCount, setcartCount } = useContext(HeaderContext)
  const { currency, getCurrencyPrice } = useContext(CurrencyContext)
  const [isPaying, setisPaying] = useState(false)
  const [processingFee, setprocessingFee] = useState(0)
  const [comment, setComment] = useState("")
  const [isStripePaymentSupported, setisStripePaymentSupported] = useState(null)
  const navigate = useNavigate()

  const stripe = useStripe()



  const AlertSupp = (prodId) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success ml-3",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: t("alertTitle.confirm"),
        text: t("removeProduct"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: t("alertButton.delete"),
        cancelButtonText: t("alertButton.cancel"),
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          fetchDeleteCart(prodId);
        }
      });
  };




  useEffect(() => {
    // always update cost on cart product change/update
    if (!productList.length) {
      return
    }
    setisPaying(true)

    axios.all([calculateTotal(productList, currency), getIsStripeSupportedCurrency(currency)]).then(axios.spread((totalResponse, issupportedResponse) => {
      setTotal(totalResponse)
      setisStripePaymentSupported(issupportedResponse)
    })).finally(() => {
      setisPaying(false)
    })
  }, [productList, currency])



  useEffect(() => {
    setisLoading(true)


    axios.all([
      fetchCart(),
    ]).then(axios.spread((cartResponse) => {

      setProductList(cartResponse.data)
    })).catch((error) => {
      showAlert("error", t("request.errorCart"))
    }).finally(() => {
      setisLoading(false)
    })
  }, []);



  async function calculateTotal(cartItems, currency) {
    let totalCost = 0;


    cartItems.map((item) => {
      if (item.produit.discount) {
        totalCost += getCurrencyPrice((item.produit.prix - (item.produit.prix / 100 * item.produit.discount)) * item.quantite, item.produit.currency)
      } else {
        totalCost += getCurrencyPrice(item.produit.prix * item.quantite, item.produit.currency)
      }

      // aggregate delivery fee
      if (item.produit.user.entreprise.deliveryFee) {
        totalCost += getCurrencyPrice(item.produit.user.entreprise.deliveryFee, item.produit.user.entreprise.currency)
      }
    })

    const processingFee = await getProcessingFee(totalCost, currency)
    setprocessingFee(processingFee)
    totalCost += processingFee


    return totalCost
  }




  function updateQt(newQt, id) {
    setisLoading(true)

    let newProductList = [];

    productList.map((cl) => {
      if (cl.id == id) {
        if (newQt >= cl.produit.min && newQt <= cl.produit.max) {
          cl.quantite = newQt;
          fetchUpdateQt(id, newQt);
        }
      }
      newProductList.push(cl);
    });


    setProductList(newProductList);


    setisLoading(false)
  }




  function fetchCart() {
    return axios.get(CART_URL)
  }




  function onOrderPlaceSuccess() {
    showAlert("success", t("orderInvoice"))
    setcartCount(0)
    setProductList([])
  }




  function fetchDeleteCart(id) {
    setisLoading(true)
    axios
      .post(DELETE_CART_URL, {
        panierId: id,
      }).then(() => {
        setcartCount(cartCount - 1)
        setProductList(productList.filter(prod => prod.id != id))

        showAlert("success", t("removedProduct"))
      }).catch(() => {

      })
      .finally(() => {
        setisLoading(false)
      });
  }





  function fetchUpdateQt(panierId, qt) {
    axios.post(UPDATE_QT_URL, {
      panierId: panierId,
      quantite: qt,
    }).catch((err) => {
      showAlert("error", t("request.errorUpdateProductQte"))
    });
  }







  async function handlePayment() {
    try {
      setisPaying(true)

      // Avoid double slashes when Global.frontend is "/"
      const basePath = (Global.frontend || "").replace(/\/$/, "");

      const response = await axios.post(CREATE_PAYMENT_SESSION, {
        currency: currency,
        successUrl: window.location.origin + basePath + "/payment",
        cancelUrl: window.location.origin + basePath + "/payment",
        comment: comment
      });

      const { id, order } = response.data

      if (order.methode_de_paiement == "cashOnDelivery") {
        navigate("/payment?status=success&orderReference=" + order.reference + "&paymentMethod=cashOnDelivery&amount=" + order.currency + " " + order.totale)
      } else {
        await stripe.redirectToCheckout({ sessionId: id })
      }
    } catch (error) {
      showAlert("error", t("request.errorOrder"));
    } finally {
      setisPaying(false)
    }
  }








  return (
    <div>

      <LoaderComponent isLoading={isLoading}>
        <>
          {(productList.length) ? (
            <div className="my-main mb-5" style={{ minHeight: "100vh" }}>
              <div className="m-5">
                <div className="row">
                  <div className="col-md-9">
                    <h1>{t('myCart')}</h1>

                    {productList.map((product, index) => (
                      <div
                        className="container cart-left-container"
                        key={index}
                      >
                        <div className="row">
                          <div className="col-md-2 cart-item cart-product-image">
                            <div style={{ height: 90, width: 100 }}>
                              <img
                                src={`${Global.backend}/uploads/${product.produit.image[0].imageURL}`}
                                style={{
                                  height: "100%",
                                  width: "100%",
                                  objectFit: "cover",
                                }}
                              />
                            </div>
                          </div>
                          <div
                            className="col-md-4 cart-item"
                            style={{
                              width: "auto",
                              display: "flex",
                              justifyContent: "left",
                              alignItems: "center",
                            }}
                          >
                            <div className="cart-product-description w-100" style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%" }}>
                              <h6>{product.produit.nom}</h6>

                              <h6 className="cart-price d-flex w-100" style={{ justifyContent: "space-between" }}>
                                {t("price")}:
                                {product.produit.discount ? (
                                  <span className="new-price">
                                    {GlobalData.currency[currency]}
                                    {getCurrencyPrice(product.produit.prix - (product.produit.prix * product.produit.discount / 100), product.produit.currency)}
                                  </span>
                                ) : (
                                  <span className="new-price">
                                    {GlobalData.currency[currency]}
                                    {getCurrencyPrice(product.produit.prix, product.produit.currency)}
                                  </span>
                                )}
                                {product.produit.discount && (
                                  <>
                                    <span className="badge badge-dark">
                                      -{product.produit.discount}%
                                    </span>

                                    <span className="old-price">
                                      {GlobalData.currency[currency]}
                                      {getCurrencyPrice(product.produit.prix, product.produit.currency)}
                                    </span>
                                  </>
                                )}
                              </h6>

                              <h6 className="cart-price d-flex w-100" style={{ justifyContent: "space-between" }}>{t("delivery")}:
                                <span className="new-price">
                                  {product.produit.user.entreprise.deliveryFee ? (
                                    `${GlobalData.currency[currency]} ${getCurrencyPrice(product.produit.user.entreprise.deliveryFee, product.produit.user.entreprise.currency)}`
                                  ) : "Free"}
                                </span>
                              </h6>
                            </div>

                          </div>


                          <div className="col-md-4 cart-item">
                            <table>
                              <tbody>
                                <tr>
                                  <td>
                                    <button
                                      className="btn product-price-btn moin"
                                      onClick={() =>
                                        updateQt(product.quantite - 1, product.id)
                                      }
                                    >
                                      -
                                    </button>
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="product-price-input d-flex justify-content-center align-items-center text-center"
                                      style={{ backgroundColor: "#F5F7FA" }}
                                      defaultValue={product.quantite}
                                      key={product.quantite}
                                    />

                                  </td>
                                  <td>
                                    <button
                                      className="btn product-price-btn plus"
                                      onClick={() =>
                                        updateQt(product.quantite + 1, product.id)
                                      }
                                    >
                                      +
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>


                          <div className="col-md-1 cart-item">
                            {product.produit.discount ? (
                              <div className="cart-product-price">
                                {GlobalData.currency[currency]}{getCurrencyPrice(product.quantite * (product.produit.prix - (product.produit.prix * product.produit.discount / 100)), product.produit.currency) + getCurrencyPrice(product.produit.user.entreprise.deliveryFee, product.produit.user.entreprise.currency)}
                              </div>
                            ) : (
                              <div className="cart-product-price">
                                {GlobalData.currency[currency]}{getCurrencyPrice(product.quantite * product.produit.prix, product.produit.currency) + getCurrencyPrice(product.produit.user.entreprise.deliveryFee, product.produit.user.entreprise.currency)}
                              </div>
                            )}
                          </div>


                          <button
                            className="col-md-1 cart-item cart-delete-icon"
                            onClick={() => AlertSupp(product.id)}
                          >
                            <AiFillDelete />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>




                  <div className="col-md-3 cart-summary-col">
                    <div className="cart-right-container">
                      <div className="row">
                        <div className="col-6">
                          {productList.length} {t("items")}
                        </div>
                        <div className="col-6 text-right">
                          {GlobalData.currency[currency]} {productList.reduce((total, item) => {
                            if (item.produit.discount) {
                              total += getCurrencyPrice((item.produit.prix - (item.produit.prix / 100 * item.produit.discount)) * item.quantite, item.produit.currency)
                            } else {
                              total += getCurrencyPrice(item.produit.prix * item.quantite, item.produit.currency)
                            }
                            return total;
                          }, 0).toFixed(2)}
                        </div>



                        <div className="col-7">{t("processingFee")}</div>
                        <div className="col-5 text-right">
                          {GlobalData.currency[currency]} {processingFee.toFixed(2)}
                        </div>



                        <div className="col-6">{t("delivery")}</div>
                        <div className="col-6 text-right">
                          {GlobalData.currency[currency]} {productList.reduce((total, product) => {
                            const deliveryFee = product.produit.user.entreprise.deliveryFee;
                            if (deliveryFee) {
                              const feeInCurrency = getCurrencyPrice(deliveryFee, product.produit.user.entreprise.currency);
                              return total + parseFloat(feeInCurrency);
                            }
                            return total;
                          }, 0).toFixed(2)}
                        </div>


                        <div className="cart-summary-divider"></div>

                        <div className="col-6">{t("total")}</div>
                        <div className="col-6 text-right">
                          {GlobalData.currency[currency]} {total.toFixed(2)}
                        </div>



                        <div className="col-6">{t("paymentMethod")}</div>
                        <div className="col-6 text-right">
                          {isStripePaymentSupported ? t("paymentMethods.stripe") : t("paymentMethods.cashOnDelivery")}
                        </div>


                        <div className="cart-summary-divider"></div>


                        <textarea
                          className="cart-summary-comment"
                          rows="3"
                          placeholder={t("comment")}
                          value={comment}
                          onChange={(e) => setComment(e.target.value)}
                        ></textarea>


                        <div className="cart-summary-actions">
                          <Button
                            className="cart-order-button"
                            sx={{ fontSize: "1.05rem" }}
                            variant="contained"
                            disabled={isPaying}
                            onClick={() => { handlePayment() }}>
                            {isPaying ? (
                              <CircularProgress size={30} />
                            ) : (
                              t("order")
                            )}

                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div
              className="container my-main mt-5 mb-5"
              style={{
                textAlign: "center",
                paddingBottom: 80,
              }}
            >
              <BsCartX
                style={{ fontSize: 280, color: "#495057", marginBottom: 20 }}
              />
              <h1 className="text-center">{t("emptyCart")}</h1>
            </div>
          )}
        </>
      </LoaderComponent>
      <Footer />
    </div>
  );
};

export default Cart;
